// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-avatar-group {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
:where(.vuetify-styles) .v-avatar-group--hoverable .v-avatar {
  cursor: pointer;
  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}
:where(.vuetify-styles) .v-avatar-group--hoverable .v-avatar:hover {
  transform: translateY(-8px);
}
:where(.vuetify-styles) .v-avatar-group--hoverable.v-avatar-group--vertical .v-avatar:hover {
  transform: translateX(8px);
}
:where(.vuetify-styles) .v-avatar-group__content {
  display: flex;
  align-items: center;
}
:where(.vuetify-styles) .v-avatar-group .v-avatar-group__overflow {
  background: rgb(var(--v-theme-surface-light));
  color: rgb(var(--v-theme-on-surface-light));
}
:where(.vuetify-styles) .v-avatar-group--horizontal .v-avatar:not(:first-child) {
  margin-inline-start: var(--v-avatar-group-gap, -12px);
}
:where(.vuetify-styles) .v-avatar-group--horizontal.v-avatar-group--reverse .v-avatar-group__content {
  flex-direction: row-reverse;
}
:where(.vuetify-styles) .v-avatar-group--horizontal.v-avatar-group--reverse {
  /* upgrade someday: https://caniuse.com/wf-sibling-count */
}
:where(.vuetify-styles) .v-avatar-group--horizontal.v-avatar-group--reverse .v-avatar:not(:first-child) {
  margin-inline-start: 0;
  margin-inline-end: var(--v-avatar-group-gap, -12px);
}
:where(.vuetify-styles) .v-avatar-group--vertical .v-avatar-group__content {
  flex-direction: column;
}
:where(.vuetify-styles) .v-avatar-group--vertical .v-avatar:not(:first-child) {
  margin-block-start: var(--v-avatar-group-gap, -12px);
}
:where(.vuetify-styles) .v-avatar-group--vertical.v-avatar-group--reverse .v-avatar-group__content {
  flex-direction: column-reverse;
}
:where(.vuetify-styles) .v-avatar-group--vertical.v-avatar-group--reverse .v-avatar:not(:first-child) {
  margin-block-start: 0;
  margin-block-end: var(--v-avatar-group-gap, -12px);
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/labs/VAvatarGroup/VAvatarGroup.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,wDAAwD;AAC1D;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,6CAA6C;EAC7C,2CAA2C;AAC7C;AACA;EACE,qDAAqD;AACvD;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,0DAA0D;AAC5D;AACA;EACE,sBAAsB;EACtB,mDAAmD;AACrD;AACA;EACE,sBAAsB;AACxB;AACA;EACE,oDAAoD;AACtD;AACA;EACE,8BAA8B;AAChC;AACA;EACE,qBAAqB;EACrB,kDAAkD;AACpD","sourcesContent":[".v-avatar-group {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n.v-avatar-group--hoverable .v-avatar {\n  cursor: pointer;\n  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-avatar-group--hoverable .v-avatar:hover {\n  transform: translateY(-8px);\n}\n.v-avatar-group--hoverable.v-avatar-group--vertical .v-avatar:hover {\n  transform: translateX(8px);\n}\n.v-avatar-group__content {\n  display: flex;\n  align-items: center;\n}\n.v-avatar-group .v-avatar-group__overflow {\n  background: rgb(var(--v-theme-surface-light));\n  color: rgb(var(--v-theme-on-surface-light));\n}\n.v-avatar-group--horizontal .v-avatar:not(:first-child) {\n  margin-inline-start: var(--v-avatar-group-gap, -12px);\n}\n.v-avatar-group--horizontal.v-avatar-group--reverse .v-avatar-group__content {\n  flex-direction: row-reverse;\n}\n.v-avatar-group--horizontal.v-avatar-group--reverse {\n  /* upgrade someday: https://caniuse.com/wf-sibling-count */\n}\n.v-avatar-group--horizontal.v-avatar-group--reverse .v-avatar:not(:first-child) {\n  margin-inline-start: 0;\n  margin-inline-end: var(--v-avatar-group-gap, -12px);\n}\n.v-avatar-group--vertical .v-avatar-group__content {\n  flex-direction: column;\n}\n.v-avatar-group--vertical .v-avatar:not(:first-child) {\n  margin-block-start: var(--v-avatar-group-gap, -12px);\n}\n.v-avatar-group--vertical.v-avatar-group--reverse .v-avatar-group__content {\n  flex-direction: column-reverse;\n}\n.v-avatar-group--vertical.v-avatar-group--reverse .v-avatar:not(:first-child) {\n  margin-block-start: 0;\n  margin-block-end: var(--v-avatar-group-gap, -12px);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
